import React, { useContext, useEffect, useState } from 'react';
import CotizadorHNProvider, { CotizadorHNDataContext } from '../../context/CotizadorHNDataContext';
import { buildTarificacionData, bulidDataToSave } from '../../data/cotizadorHnData';
import useToken from '../../hooks/useToken';
import { ImgAlert, ImgNext, ImgAlertOk } from '../../svg';
import ControlButton from '../../components/controls/ControlButton';
import Pages from './Pages';
import tarificar, { calculatePrima, computeRateResult, getResumen } from '../../services/tarificar'
import '../../cotizadorcr.css'
import Modal from 'react-modal';
import { customStyles, endPoints } from '../../utils/constanst';
import DivRow from '../../components/controls/DivRow';
import http from '../../services/http';

import Loading from '../../components/controls/Loading';
import Container from '../../components/Container';

const CotizadorHN = ({ ...rest }) => {

    const { loading } = useToken();

    useEffect(() => {

        if (!loading) {

            setTimeout(() => {
                const preloader = document.querySelector('.site-preloader');

                if (preloader) {
                    preloader.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'opacity') {
                            preloader.parentNode.removeChild(preloader);
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                }
            }, 600);

        }

    }, [loading]);



    return (
        <Container>
            <div>{!loading &&

                <Layout></Layout>

            }
            </div>
        </Container>
    );
}

const Layout = ({ loading, ...rest }) => {

    const valMsgDefault = { showDialog: false, field: '' };

    const [validationObj, setValidationObj] = useState({ ...valMsgDefault });
    const [index, setIndex] = useState(0);
    const { poliza, setPoliza, tarificacion, setTarificacion, catalogos } = useContext(CotizadorHNDataContext);

    const [ofertaCreada, setOfertaCreada] = useState(false);

    const [descargando, setDescargando] = useState(false);

    const contentTitles = [
        'Datos personales',
        'Actividad económica',
        'Declaración de salud',
        'Declaración de Beneficiarios',
        'Otros seguros',
        'Pago de póliza'
    ]

    const pages = contentTitles.length - 1;

    const textNext = index === pages ? 'Finalizar' : 'Siguiente';

    const decrement = () => {
        if (index !== 0)
            setIndex(index - 1);
        else
            back();
    };

    const increment = disabled => {

        if (index !== pages)
            setIndex(index + 1);
    }

    const back = () => {
        rest.history.push('/', { data: null });
    }

    const execute = i => {
        //console.log(i);
        return new Promise((resolve, reject) => {

            if (i === 0) //tarificar
            {
                let data = buildTarificacionData(poliza.planId, tarificacion);
                setTarificacion(data);


                const tarificarPlan = tarificar(poliza.planId);

                tarificarPlan(data).then(resp => {

                    setPoliza(computeRateResult(poliza, resp.rates));

                    resolve(resp);

                }).catch(error => {

                    setTarificacion({ showDialogFail: true, errorMsg: error });

                    reject(error);
                });

                //resolve({})

            } else if (i === 1) {
                if (!ofertaCreada) {
                    setOfertaCreada(true);
                    crearOferta();
                }
                openModalFinish();
            }
            // resolve({})

        })
    }





    const handleSubmit = async (e) => {

        let result = document.querySelector('form').reportValidity();

        //console.log(index);

        if (result && validateSelects()) {

            await execute(index);

            // result = validateQuestions(index);
            // if (result)
            increment(true);
        }
    }

    const validateSelects = () => {

        if (poliza.ncuotas == null) {
            setValidationObj({ showDialog: true, field: 'Frecuencia de pago' });
            return false;
        }

        if (tarificacion.marc == null || tarificacion.marc <= 0) {
            setValidationObj({ showDialog: true, field: 'Marca' });
            return false;
        }

        // if (tarificacion.dedu == null || tarificacion.dedu <= 0) {
        //     setValidationObj({ showDialog: true, field: 'Deducibles' });
        //     return false;
        // }

        if (tarificacion.mode == null || tarificacion.mode < 0) {
            setValidationObj({ showDialog: true, field: 'Modelo' });
            return false;
        }

        if (tarificacion.anio == null || tarificacion.anio <= 0) {
            setValidationObj({ showDialog: true, field: 'Año' });
            return false;
        }

        if (tarificacion.usoo == null) {
            setValidationObj({ showDialog: true, field: 'Uso del Vehículo' });
            return false;
        }



        return true;
    }

    const openModalFinish = () => setPoliza({ ...poliza, showDialogFinish: true });
    const closeModalFinish = () => setPoliza({ ...poliza, showDialogFinish: false });

    const crearOferta = () => {
        //console.log(poliza);
        let data = bulidDataToSave(poliza, tarificacion, catalogos);
        http(endPoints.createCotizadorHn).post(data).then(r => {
            setPoliza({ ...poliza, id: r.id });
            sendWelcome(r.id, data.asegurado);
        });
    }

    const descargarCotizacion = () => {

        setDescargando(true);
        http(endPoints.descargarOferta(poliza.id)).get().then(blob => {
            setDescargando(false);
        });

    }

    const closeTarificacionFail = () => setTarificacion({ showDialogFail: false, errorMsg: '' });


    const sendWelcome = (polizaId, data) => {

        http(endPoints.welcomeNotificationCR(polizaId)).post(data);

    }

    const finalizar = () => {


        window.location.href = '/ProductosDigitales/micrositio/automovilhn';
    }

    return (
        <div className="layoutcr">
            <div className="header-section">
                <h2 className="txt-esmeralda txt-light text-center">¡Cotiza tu seguro Aquí!</h2>
                <h3 className="txt-light text-center" style={{ paddingLeft: '22px', paddingRight: '22px' }}>Con tu póliza de Auto Seguro LAFISE disfruta<br/> cada momento sin preocupaciones</h3>
            </div>

            <form className="d-grid">
                <Pages indexProgress={index} />
                <ControlButton>
                   
                        <button className={`control-button-btn prev`}
                            type="button"
                            onClick={decrement} style={{visibility:index!=0?'visible':'hidden'}} >Regresar</button>
                    


                    {index < pages &&
                        <button className="control-button-btn next"
                            type="button"
                            onClick={handleSubmit}>
                            {textNext}
                            {index !== pages && <ImgNext />}
                        </button>
                    }
                </ControlButton>
                <Modal
                    isOpen={poliza.showDialogFinish}
                    onRequestClose={closeModalFinish}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    ariaHideApp={false}
                >

                    <div>
                        <div className="dialog-center-content">
                            <h2 className="text-center txt-primary">¡Su cotización esta lista!</h2>
                        </div>
                        <div className="dialog-center-content">
                            <ImgAlertOk />
                        </div>
                        <div className="dialog-center-content">
                            <p className="text-center txt-muted txt-ft-12">Un ejecutivo de <strong>Seguros LAFISE</strong> se comunicará contigo lo antes posible, o bien nos puedes contactar en nuestra central telefónica <strong>2237-4000 Ext. 10960</strong>, estamos para servirte de 8:30 a.m. a 5 p.m. de lunes a viernes.</p>
                        </div>
                        <div className="mt-50"></div>
                        <div className="step">
                            <DivRow width="50%">
                                <div className="dialog-center-content">
                                    <button type="button" className="control-button-btn btn-color-secondary" onClick={descargarCotizacion} disabled={poliza.id === 0 || descargando}>
                                        {poliza.id === 0 ? 'Creando Cotización...' : (descargando ? '' : 'Descargar Cotización')}
                                        {poliza.id !== 0 && descargando ? 'Descargando Cotización...' : ''}
                                    </button>
                                </div>
                            </DivRow>
                            <DivRow width="50%">
                                <div className="dialog-center-content">
                                    <button type="button" className="control-button-btn btn-color-primary" onClick={finalizar}>Contactenme</button>
                                </div>
                            </DivRow>
                        </div>


                    </div>

                </Modal>
                <Modal
                    isOpen={tarificacion.showDialogFail}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <h2 className="txt-primary txt-center">
                        Se nos ha presentado un inconveniente
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted txt-center">Ha ocurrido un error al calcular la tarifa.<br />
                        {tarificacion.errorMsg}
                    </h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeTarificacionFail}>Entendido</button>
                    </div>
                </Modal>
                {/* Mensaje de validaciòn */}
                <Modal
                    isOpen={validationObj.showDialog}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <h2 className="txt-primary txt-center">
                        Ingrese todos los datos.
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted txt-center">Especifique un valor para el campo: <br />
                        <strong> {validationObj.field}</strong>
                    </h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={() => setValidationObj({ ...valMsgDefault })}>Entendido</button>
                    </div>
                </Modal>

            </form>
        </div>
    );
}

export default CotizadorHN;
